import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bauen-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input() message: string = 'Cargando';
  constructor() {}

  ngOnInit(): void {}
}
